export enum MessageType {
  SystemMsg = 'system',
  ErrorMsg = 'error',
  AiMsg = 'ai',
  UserMsg = 'user',
  InterruptMsg = 'interrupt',
  WorkflowSavedMsg = 'workflow_saved',
  WorkflowTestMsg = 'workflow_test',
}

export type Message = {
  id?: string
  author?: string
  message: string
  type?: MessageType
  pass_to_human?: boolean
  thinking?: string
  feedback?: FeedbackType
  commited?: boolean
  reasoning?: any
  tool_calls?: any
  audio_url?: string
  image?: string
}

export enum FeedbackType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export type MessageRequest = {
  query: string
  agentId: string
  session_id?: string | null
  image?: string | null
}

export type SendFeedbackPayload = {
  agentId: string
  feedbackType: FeedbackType
  requestId: string
  sessionId: string
  reason?: string
  message?: string
}
